module Common {
    export class Application {
        static isValidPeriod(periodValue) {
            try {

                var month = Number(periodValue.split("/")[0]);
                var year = Number(periodValue.split("/")[1]);
                if (isNaN(month) || month > 12 || month <= 0)
                    return false;
                if (isNaN(year) || year < 1990 || year > 2114)
                    return false;
                return true;
            } catch (e) {
                return false;
            }
        }

        static showAjaxLoader() {
            var loaderDiv = $("#__AjaxLoader");
            if (loaderDiv.length === 0) {
                //create ajax loader div tag, if not present
                loaderDiv = $("<DIV/>")
                    .attr("id", "__AjaxLoader")
                    .css("position", "absolute")
                    .css("display", "block")
                    .css("z-index", "10005")
                    .addClass("ajaxLoader");
                loaderDiv.appendTo("body");
            }

            //center ajax loader div tag in the browser window
            var doc = $(document);
            loaderDiv.css('top', (doc.height() - loaderDiv.height()) / 2);
            loaderDiv.css('left', (doc.width() - loaderDiv.width()) / 2);

            loaderDiv.show();
        }

        static hideAjaxLoader() {
            //hide ajax loader div tag, if present
            $("#__AjaxLoader").hide();
        }

        static setGridFilter(currentFilters, filterField, filterOperator, filterValue, perserveCurrent) {
            if (currentFilters && currentFilters.length > 0) {
                for (var i = 0; i < currentFilters.length; i++) {
                    var filter = currentFilters[i];
                    //Remove current filter 
                    //If preserve is false (needed when adding multiple filters on the same field)
                    //Or has the same operator.
                    if (filter.field == filterField && (!perserveCurrent || filterOperator == filter.operator))
                        currentFilters.splice(i, 1);
                }
            }
            // No need to set the filter if no value was provided
            if (filterValue != null && filterValue != "")
                currentFilters.push({ field: filterField, operator: filterOperator, value: filterValue });

            return currentFilters;
        }

    }

    export class GridFilterOperators {
        static equal = "eq";
        static greaterThan = "gt";
        static greaterThanOrEqual = "gte";
        static lessThan = "lt";
        static lessThanOrEqual = "lte";
        static notEqualOperator = "neq";
        static contains = "contains";
        static doesNotContain = "doesnotcontain";
    }
}